<template>
  <BoxedFrame title="Promoter profit">
    <section>
      <div class="section section-row bold div-5">
        <div class="row-label triple-f">
          Promoter Profit
        </div>
        <Form
          :form-id="PROMOTER_PROFIT_FORM_ID"
          :initial-values="{ promoterProfitPercentage }"
          action="#"
        >
          <HiddenInput input-id="id" />

          <VPPercentageInput
            ref="promoterProfitPercentageRef"
            input-id="promoterProfitPercentage"
            placeholder="Add data"
            class="right-field"
            hide-empty-input
            @blur="promoterProfitSave"
          />
        </Form>
        <div class="right-field">
          {{ formatCurrency(promoterProfit, { onZero: '-' }) }}
        </div>
      </div>
    </section>
  </BoxedFrame>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import BoxedFrame from '@/components/BoxedFrame.vue';
import { Form, HiddenInput, useFormsStore } from 'vuniform';
import VPPercentageInput from '@/components/form/VPPercentageInput.vue';
import { useOfferSheetFormStore, PROMOTER_PROFIT_FORM_ID } from '@/stores/offer-sheet-form';
import { useOfferSheetStore } from '@/stores/offer-sheet';
import { formatCurrency } from '@/helpers/currency';

const offerSheetStore = useOfferSheetStore();
const offerSheetFormStore = useOfferSheetFormStore();
const formsStore = useFormsStore();

const promoterProfitPercentage = computed(() => offerSheetStore.offerSheet?.promoterProfitPercentage);

const loading = computed(() => offerSheetStore.offerSheetLoading);
const offerSheet = computed(() => offerSheetStore.offerSheet);

const promoterProfit = computed(() => offerSheetFormStore.promoterProfit);

const promoterProfitSave = async () => {
  if (loading.value || !formsStore.isFieldDirty(PROMOTER_PROFIT_FORM_ID, 'promoterProfitPercentage')) {
    return;
  }

  offerSheetStore.updateOfferSheet(
    {
      id: offerSheetStore.offerSheet.id,
      promoterProfitPercentage: offerSheetFormStore.promoterProfitPercentage,
    },
    ['promoterProfitPercentage'],
  );

  formsStore.SET_INITIAL_VALUES({
    values: { ...offerSheet.value },
    formId: PROMOTER_PROFIT_FORM_ID,
    clearDirty: true,
  });
};
</script>
